export const TOKEN_TYPE = ''
export const REQUEST_HEADER_AUTH_KEY = 'token'
